export default __webpack_public_path__ + "static/media/Grips of the Endless Sands.b0a826df.jpg";